import { render, staticRenderFns } from "./CollapseFormItem.vue?vue&type=template&id=48028372"
import script from "./CollapseFormItem.vue?vue&type=script&lang=js"
export * from "./CollapseFormItem.vue?vue&type=script&lang=js"
import style0 from "./CollapseFormItem.vue?vue&type=style&index=0&id=48028372&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports